import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';
import { ADMIN_AI_LOCAL_API_REQUESTS } from './constants';

/**
 * POST /chatbot-analytics/activate-licence — creates the business's AI
 * assistant licence row, or replaces a cancelled one, as active; system
 * admin only.
 */
export const activateAiLicence = async ({ businessId, businessName }) => {
  const signedRequest = await createSignedPostRequest({
    apiPath: 'chatbot-analytics/activate-licence',
    body: { businessId, businessName },
    isLocalApiRequest: ADMIN_AI_LOCAL_API_REQUESTS,
  });
  const response = await axios(signedRequest);
  return response.data;
};
